import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/ui/badge";
import { discountFraction } from "@llmgateway/shared";
import { isMappingDeactivated } from "@llmgateway/shared/components";
import type { ApiModelProviderMapping } from "@/lib/fetch-models";
export function ModelDiscountBadge(t0) {
  const $ = _c(5);
  const {
    mappings,
    exact: t1
  } = t0;
  const exact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== mappings) {
    t2 = Math.max(0, ...mappings.filter(_temp).map(_temp2));
    $[0] = mappings;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const discount = t2;
  let t3;
  if ($[2] !== discount || $[3] !== exact) {
    t3 = discount > 0 ? <Badge className="bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20 text-xs">{!exact && "Up to "}{Math.round(discount * 100)}% off</Badge> : null;
    $[2] = discount;
    $[3] = exact;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2(mapping_0) {
  return discountFraction(mapping_0.discount);
}
function _temp(mapping) {
  return mapping.status === "active" && !isMappingDeactivated(mapping);
}